import { render, staticRenderFns } from "./HoverTooltipProduct.vue?vue&type=template&id=36d2ceb2&"
import script from "./HoverTooltipProduct.vue?vue&type=script&lang=js&"
export * from "./HoverTooltipProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports